import React from 'react'

// 👇 Only important line - as this component should be lazy-loaded,
//    to enable code - splitting for this CSS.
import './ihr-podcasters.scss';

const ThemeIhrPodcasters = () => {
  //console.debug('ThemeIhrPodcasters');
  return (<></>)
};

export default ThemeIhrPodcasters;